export default function scope(existing, ...args) {
  if (args.length > 0) {
    return [...existing, args]
  } else {
    return existing
  }
}



// WEBPACK FOOTER //
// ./src/config/features/scope.js